import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=226570e6&scoped=true"
import script from "./BlogsList.vue?vue&type=script&lang=js"
export * from "./BlogsList.vue?vue&type=script&lang=js"
import style0 from "./BlogsList.vue?vue&type=style&index=0&id=226570e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226570e6",
  null
  
)

export default component.exports